export default "__VITE_ASSET__CJ2j00qh__"